// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IAvailableJkSchema } from './AvailableJkSchema';
import type { IPromoBankSchema } from './PromoBankSchema';
import type { IPromoFeatureSchema } from './PromoFeatureSchema';
import type { IPromoMortgageParamsSchema } from './PromoMortgageParamsSchema';

export interface IPromoSchema {
  /** Логотип застройщика/агента **/
  authorLogoUrl?: string;
  /** Название застройщика/агента **/
  authorName?: string;
  /** ID застройщика/агента **/
  authorRealtyUserId?: number;
  /** Доступные ЖК **/
  availableJks?: IAvailableJkSchema[];
  /** Банк - автор **/
  bank?: IPromoBankSchema;
  /** Банки **/
  banks?: IPromoBankSchema[];
  /** ID компании, разместившей акцию **/
  companyId?: number;
  /** Описание акции **/
  description?: string;
  /** Срок действия акции **/
  end?: string;
  /** Фичи **/
  features?: IPromoFeatureSchema[];
  /** Акция Черной Пятницы **/
  isBlackFriday?: boolean;
  /** Акция от банка **/
  isFromBank?: boolean;
  /** Акция от застройщика **/
  isFromBuilder?: boolean;
  /** Параметры ипотеки для промоакции с типом ипотека **/
  mortgageParams?: IPromoMortgageParamsSchema;
  /** Название акции **/
  name: string;
  /** Изображение для акции **/
  promoImage?: string;
  /** Источник акции **/
  promoSource?: string;
  /** Тип акции **/
  promoType?: EPromoType;
  /** Дата начала действия акции **/
  start?: string;
  /** Подзаголовок акции **/
  subtitle?: string;
  /** ID акции **/
  uniquePromoId: string;
}

export enum EPromoType {
  /** Акция от банка **/
  'Bank' = 'bank',
  /** Бонусы **/
  'Bonus' = 'bonus',
  /** Циан ипотека **/
  'CianMortgage' = 'cianMortgage',
  /** Скидки **/
  'Discount' = 'discount',
  /** Материнский капитал **/
  'MaternalCapital' = 'maternalCapital',
  /** Военная ипотека **/
  'MilitaryMortgage' = 'militaryMortgage',
  /** Ипотека **/
  'Mortgage' = 'mortgage',
}
